<label *transloco="let t" class="min-h-40!" data-testid="attachment-drop-zone" tuiInputFiles>
  <input
    data-testid="attachment-file-input"
    tuiInputFiles
    [accept]="fileAcceptTypes"
    [multiple]="true"
    [ngModel]="undefined"
    (ngModelChange)="onFilesAdded($event)"
    (reject)="showUnsupportedFilesWarning()" />
  <ng-template let-dragged>
    <pxc-dropzone-content
      [isDragged]="dragged"
      [label]="t('Sélectionnez ou déposez un fichier ({{types}})', { types: fileAcceptTypes })" />
  </ng-template>
</label>
